module.exports = __webpack_public_path__ + "static/assets/9bf51644cf5676349aefdfe6e990f4ac.png";